<div style="display: flex; flex-direction: line; justify-content: space-between; align-items: baseline;">
    @if (mode === 'Update') {
    <h2>Edit event</h2>
    } @else {
    <h2>Create new event</h2>
    }
    <div class="n-last-modifications">
        @if (event.lastModifiedOn) {
        Last update: {{event | lastUpdate}}
        }
    </div>
</div>

<form [formGroup]="form" class="form-container">
    <div style="display: flex; flex-direction: column; padding: 10px; gap: 10px;">
        <mat-form-field appearance="outline" [style.width]="200">
            <mat-label>Event name</mat-label>
            <input matInput type="text" formControlName="name" />
            @if(form.get('name')?.invalid) {
            <mat-error> Event name is required. </mat-error>
            }
            <mat-hint>
                @if ((duplicateEntryResource.status() == 'resolved') &&
                (((duplicateEntryResource.value()?.matchingItems ?? []).length > 0) ||
                ((duplicateEntryResource.value()?.similarItems ?? []).length > 0))){
                <span class="n-duplicate-warning">{{ duplicateEntryResource.value() |
                    similarityList:'nameSimilarity':0.95:'name' }}</span>
                }
                @if (duplicateEntryResource.status() == 'error') {
                <span class="n-duplicate-error">Error checking for similar entries</span>
                }
            </mat-hint>
            <ng-container matSuffix>
                @if (duplicateEntryResource.status() == 'loading') {
                <div class="n-spinner-container">
                    <mat-spinner diameter="32"></mat-spinner>
                </div>
                }
            </ng-container>
        </mat-form-field>


        <mat-form-field appearance="outline" [style.width.%]="100">
            <mat-label>Short description</mat-label>
            <textarea rows="4" matInput type="text" formControlName="description" maxlength="500"></textarea>
            <mat-hint align="end">{{ form.get('description')?.value?.length || 0 }}/500</mat-hint>
        </mat-form-field>
        <div style="display: flex; flex-direction: column; gap: 15px;">
            <div style="display: flex; flex-direction: row; gap: 15px;">
                <mat-form-field appearance="outline" [style.width.px]="300">
                    <mat-label>Start date</mat-label>
                    <input matInput [matDatepicker]="startPicker" formControlName="date">
                    <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
                    <mat-datepicker #startPicker></mat-datepicker>
                    <mat-hint>
                        Format: dd/MM/yyyy
                    </mat-hint>
                    <mat-error>Date is invalid</mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline" [style.width.px]="300">
                    <mat-label>End date</mat-label>
                    <input matInput [matDatepicker]="endPicker" formControlName="endDate">
                    <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
                    <mat-datepicker #endPicker></mat-datepicker>
                </mat-form-field>
                <mat-form-field appearance="outline" [style.width.px]="300">
                    <mat-label>Attendance Type</mat-label>
                    <mat-select formControlName="attendanceType">
                        @for (option of attendanceOptions; track option.value) {
                        <mat-option [value]="option.value">{{ option.label }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="outline" [style.width.px]="300">
                    <mat-label>Responsible person</mat-label>
                    <input matInput type="text" [matAutocomplete]="userAuto" formControlName="responsiblePerson">
                    <mat-autocomplete #userAuto="matAutocomplete">
                        @for (u of allUsers(); track u) {
                        <mat-option [value]="u.displayName">{{u.displayName}}</mat-option>
                        }
                    </mat-autocomplete>
                </mat-form-field>
            </div>
            @if ((duplicateEntryResource.status() == 'resolved') &&
            (((duplicateEntryResource.value()?.matchingItems ?? []).length > 0) ||
            ((duplicateEntryResource.value()?.similarItems ?? []).length > 0))){
            <span class="n-duplicate-warning" style="font-size: 12px; margin-top: -12px; margin-left: 19px">{{
                duplicateEntryResource.value() | eventSimilarityList:'dateSimilarity':0.999:'date' }}</span>
            }
            @if (duplicateEntryResource.status() == 'error') {
            <span class="n-duplicate-error">Error checking for similar entries</span>
            }
        </div>

        <mat-form-field appearance="outline">
            <mat-label>Event types</mat-label>
            <app-advanced-chip-select #eventTypesSelect placeholder="New event type..." formControlName="eventTypes"
                [allOptions]="allEventTypeOptions()" [required]="true" />
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>Topics of interest</mat-label>
            <app-advanced-chip-select #topicsSelect required placeholder="New topic of interest..."
                formControlName="topics" [allOptions]="allTopicOptions()" />
            <mat-hint>Aim at no more than 5 topics</mat-hint>
            <mat-error>Select at least one topic</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>Related projects</mat-label>
            <app-advanced-chip-select #topicsSelect placeholder="New related project..." formControlName="projects"
                [allOptions]="allProjectOptions()" />
            <mat-hint>You can add new projects from the <i>projects</i> screen.</mat-hint>
        </mat-form-field>

        <mat-form-field appearance="outline" [style.width]="200">
            <mat-icon matPrefix>folder</mat-icon>
            <mat-label>Drive folder</mat-label>
            <input matInput type="text" formControlName="driveFolder">
            <mat-hint>Add path to S drive folder where evidence is stored</mat-hint>
        </mat-form-field>
        <div style="display: flex; gap: 0.5rem">
            <mat-form-field appearance="outline" [style.width]="200" style="flex: 1">
                <mat-icon matPrefix>link</mat-icon>
                <mat-label>Website</mat-label>
                <input matInput type="text" formControlName="website">
                <mat-hint>Link to EUFIC website page or another official page</mat-hint>
            </mat-form-field>
            <button matMiniFab style="flex-shrink: 0" [disabled]="!form.get('website')?.value" (click)="copyLink()"
                title="Copy to clipboard"><mat-icon>content_copy</mat-icon></button>
            <button matMiniFab style="flex-shrink: 0" [disabled]="!form.get('website')?.value" (click)="openLink()"
                title="Open in a new window"><mat-icon>open_in_new</mat-icon></button>
        </div>
    </div>
</form>

@if (event.id) {
<app-history-panel entityType="event" [entityId]="event.id"></app-history-panel>
}

<div class="n-button-row">
    <button matFab extended class="n-cancel-button" (click)="cancel()"><mat-icon>cancel</mat-icon>Cancel</button>
    <button matFab extended class="n-save-button" [disabled]="form.invalid" (click)="save()"><mat-icon>save</mat-icon>{{
        (mode === 'Create' ?
        'Save' : 'Update')}}</button>
    @if (mode === "Update") {
    <button matFab extended class="n-delete-button" [disabled]="!authService.isAdmin" (click)="delete()">
        <mat-icon>delete</mat-icon>
        Delete
    </button>
    }
    <!-- @if (mode === 'Update') {
    <button matFab extended class="n-delete-button" (click)="delete()"><mat-icon>delete</mat-icon>Delete</button>
    } -->
</div>